import { render, staticRenderFns } from "./SkeletonCardNews.vue?vue&type=template&id=58f85832"
import script from "./SkeletonCardNews.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonCardNews.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports